import CardResumoPropostas from '../card-resumo-propostas.vue';
import ModalCardFinancial from './ModalCardFinancial/ModalCardFinancial.vue';
import { FINANCIAL_STATUS } from '../../../../utils/constants';
import FilterFinancialDashboard from '../../../filtros/FilterFinancialDashboard/FilterFinancialDashboard.vue';
import reportsApi from '../../../../services/reports.api';
import notify from '../../../../utils/notify';
import user from '../../../../utils/user';
import { USER_ROLES } from '../../../../constants/user';

const initialDueDaysFilter = FINANCIAL_STATUS.DUE_NEXT_DAYS.dueDays;

export default {
  name: 'DashboardFinancial',
  props: {
    completePermission: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CardResumoPropostas,
    ModalCardFinancial,
    FilterFinancialDashboard,
  },
  computed: {
    showFilterBroker: {
      get() {
        return (
          user.getUserRole() !== USER_ROLES.BROKER || this.completePermission
        );
      },
    },
    initialGeneralFilters: {
      get() {
        const initialGeneralFilters = {
          policyNumber: null,
          insuredDocument: null,
          vehiclePlate: null,
          brokerId: null,
        };

        return this.showFilterBroker
          ? initialGeneralFilters
          : { ...initialGeneralFilters, brokerId: user.getUserBrokerId() };
      },
    },
  },
  data() {
    return {
      FINANCIAL_STATUS,
      numPoliciesByCard: {},
      showModalCardFinancial: false,
      modalCardFinancialTitle: '',
      modalCardNumPolicies: 0,
      modalCardFilters: {},
      generalFilters: this.initialGeneralFilters,
      dueDaysFilter: initialDueDaysFilter,
    };
  },
  async created() {
    this.fetchData();
  },
  methods: {
    async applyFilters(newFilters) {
      this.dueDaysFilter = newFilters.dueDays
        ? newFilters.dueDays
        : initialDueDaysFilter;
      this.generalFilters = { ...newFilters };
      await this.fetchData();
    },
    async removeFilters() {
      this.dueDaysFilter = initialDueDaysFilter;
      this.generalFilters = this.initialGeneralFilters;
      await this.fetchData();
    },
    async fetchData() {
      this.$vs.loading();
      try {
        const dueDaysArray = [
          FINANCIAL_STATUS.OVERDUE.dueDays,
          FINANCIAL_STATUS.DUE_TODAY.dueDays,
          this.dueDaysFilter,
        ];
        const payload = {
          ...this.generalFilters,
          dueDays: dueDaysArray.join(','),
        };

        const data = await reportsApi.getFinancialReportCount(payload);

        const numPoliciesByCard = {
          OVERDUE: data[FINANCIAL_STATUS.OVERDUE.dueDays],
          DUE_TODAY: data[FINANCIAL_STATUS.DUE_TODAY.dueDays],
          DUE_NEXT_DAYS: data[this.dueDaysFilter],
        };

        this.numPoliciesByCard = numPoliciesByCard;
        this.$vs.loading.close();
      } catch {
        notify.notifyFail(this.$vs, 'Erro ao buscar dados financeiros');
        this.$vs.loading.close();
      }
    },
    openModalCardFinancial(cardType) {
      const isDueDaysCard = cardType === 'DUE_NEXT_DAYS';
      this.modalCardFinancialTitle = isDueDaysCard
        ? `Próximos ${this.dueDaysFilter} Dias`
        : FINANCIAL_STATUS[cardType].label;
      const modalCardFiltersDueDays = isDueDaysCard
        ? this.dueDaysFilter
        : FINANCIAL_STATUS[cardType].dueDays;

      this.modalCardFilters = {
        ...this.generalFilters,
        dueDays: modalCardFiltersDueDays,
      };
      this.modalCardNumPolicies = this.numPoliciesByCard[cardType];
      this.showModalCardFinancial = true;
    },
    closeModalCardFinancial() {
      this.showModalCardFinancial = false;
    },
  },
};
